import Container from "react-bootstrap/Container";

function Footer() {
  return (
    <footer className="bg-dark">
      <Container>
        <p className="text-light text-center m-0 py-3">
           Toate drepturile rezervate.
        </p>
      </Container>
    </footer>
  );
}

export default Footer;
